import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Usuario } from '../../pages/usuarios/usuario.model';
import { environment } from '../../../environments/environment';
import { ServerDataSource } from 'ng2-smart-table';
import { Http } from '@angular/http';
import { ServerSourceConf } from 'ng2-smart-table/lib/data-source/server/server-source.conf';
import { LoaderService } from '../loader/loader.service';
import 'rxjs/add/operator/finally';
import { UsuarioEstabelecimento } from '../../pages/usuarios/modal-estabelecimentos/usuarioEstabelecimento';

@Injectable()
export class UsuarioService {

	apiUrl:string;
	constructor(private router: Router, private http: HttpClient, private loader:LoaderService) {
		this.apiUrl = environment.apiUrl;
	}

	carregar(id:number){
		this.loader.show();
		return this.http.get<Usuario>(this.apiUrl + '/usuario/'+id).finally(() =>{
			this.loader.hide();
		});
	}

	toggleEstabelecimento(entidade:UsuarioEstabelecimento){
		this.loader.show();
		return this.http.post<any>(this.apiUrl + '/usuario/toggle-vinculo', entidade).finally(() =>{
			this.loader.hide();
		});
	}

	carregarHash(hash:string){
		return this.http.get<Usuario>(this.apiUrl + '/usuario/hash/'+hash);
	}
	cadastrar(Usuario:Usuario){
		this.loader.show();
		return this.http.post(this.apiUrl+"/usuario",Usuario).finally(()=>{
			this.loader.hide();
		});
	}

	atualizar(Usuario:Usuario){
		this.loader.show();
		return this.http.put(this.apiUrl +"/usuario",Usuario).finally(()=>{
			this.loader.hide();
		});
	}

	listar(filtro:ServerSourceConf){
		filtro.endPoint = this.apiUrl +"/usuario";
		return new ServerDataSource(Http.prototype, filtro);
	}

	deletar(id:number){
		this.loader.show();
		return this.http.delete(this.apiUrl+'/usuario/'+id).finally(()=>{
			this.loader.hide();
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/services/usuario/usuario.service.ts